import { Component } from 'react'
import * as styles from 'components/features/socialFeed/FeedPeerGroupsHeader/FeedPeerGroupsHeader.styl'
import * as cn from 'classnames'
import { Kebab } from 'components/features/pfm/Kebab/Kebab'
import { SelectableFeedFilter, FeedFilterQuery } from 'interfaces/feed'
import { PeergroupRelation } from 'interfaces/peergroups'
import { SidebarPaneState } from 'interfaces/sidebar'

export type FeedPeerGroupsHeaderStateProps = {
  selected: SelectableFeedFilter | null
  yourRelation: PeergroupRelation
  shownSidebarPane: string | null
  hasNewPosts: {
    you: boolean,
    peers: boolean
    everyone: boolean
    others: boolean
    followed_people: boolean
    followed_tags: boolean
    followed_posts: boolean
  }
}

export type FeedPeerGroupsHeaderDispatchProps = {
  onSelectFilter: (filter: SelectableFeedFilter) => void
  onTogglePeergroups: (pane: SidebarPaneState) => void
}

export type FeedPeerGroupsHeaderOwnProps = {
  queries: FeedFilterQuery[]
}

type FeedPeerGroupsHeaderProps =
  & FeedPeerGroupsHeaderStateProps
  & FeedPeerGroupsHeaderDispatchProps
  & FeedPeerGroupsHeaderOwnProps

const FilterButton = ({ title, isSelected, onClick, themeClass, hasNewPosts }: any) => (
  <button className={ styles.item } onClick={ onClick }>
    { hasNewPosts && <div className={ styles.newBadge }>New</div> }
    <div className={ cn(styles.peerGroupBorder, themeClass) }>
      { isSelected && <div className={ styles.peerGroupCircle } /> }
    </div>
    <span className={ styles.itemText }>{ title }</span>
  </button>
)

export class FeedPeerGroupsHeader extends Component<FeedPeerGroupsHeaderProps> {
  render () {
    const {
      selected,
      yourRelation,
      shownSidebarPane,
    } = this.props

    const isMemberSelected = !!selected && selected.type === 'your-posts'
    const isPeersSelected = !!selected && selected.type === 'peergroup' && selected.relationId === yourRelation.id
    const isEveryoneSelected = !!selected && selected.type === 'feedgroup' && selected.slug === 'everyone'
    const isFollowedPeopleSelected = !!selected && selected.type === 'feedgroup' && selected.slug === 'followed_people'
    const isFollowedTagsSelected = !!selected && selected.type === 'feedgroup' && selected.slug === 'followed_tags'
    const isFollowedPostsSelected = !!selected && selected.type === 'feedgroup' && selected.slug === 'followed_posts'

    return (
      <div className={ styles.container }>
        <FilterButton
          title='Your Posts'
          isSelected={ isMemberSelected }
          onClick={ this.handleSelectYourPosts }
          themeClass={ styles.member }
          hasNewPosts={ this.props.hasNewPosts.you }
        />
        <FilterButton
          title='Your Peers'
          isSelected={ isPeersSelected }
          onClick={ this.handleSelectPeers }
          themeClass={ styles.peers }
          hasNewPosts={ this.props.hasNewPosts.peers }
        />
        <FilterButton
          title='Everyone'
          isSelected={ isEveryoneSelected }
          onClick={ this.handleSelectEveryone }
          themeClass={ styles.everyone }
          hasNewPosts={ this.props.hasNewPosts.everyone }
        />
        <div className={ styles.hideOnMobile }>
          <FilterButton
            title='Followed People'
            isSelected={ isFollowedPeopleSelected }
            onClick={ this.handleSelectFollowedPeople }
            themeClass={ styles.followed }
            hasNewPosts={ this.props.hasNewPosts.followed_people }
          />
          <FilterButton
            title='Followed Tags'
            isSelected={ isFollowedTagsSelected }
            onClick={ this.handleSelectFollowedTags }
            themeClass={ styles.followed }
            hasNewPosts={ this.props.hasNewPosts.followed_tags }
          />
          <FilterButton
            title='Followed Posts'
            isSelected={ isFollowedPostsSelected }
            onClick={ this.handleSelectFollowedPosts }
            themeClass={ styles.followed }
            hasNewPosts={ this.props.hasNewPosts.followed_posts }
          />
        </div>
        <button className={ cn(styles.item, styles.kebabWrapper) } onClick={ this.handleKebabClick }>
          { this.props.hasNewPosts.others && <div className={ styles.newBadge }>New</div> }
          <div className={ styles.kebab }>
            <Kebab expanded={ shownSidebarPane === 'groups' } />
          </div>
          <span className={ cn(styles.itemText, styles.kebabItemText) }>Other Filters</span>
        </button>
      </div>
    )
  }

  private handleKebabClick = () => {
    const { shownSidebarPane, onTogglePeergroups } = this.props
    const paneId = shownSidebarPane === 'groups' ? null : 'groups'
    return onTogglePeergroups(paneId)
  }

  private handleSelectYourPosts = () => {
    const { onSelectFilter } = this.props
    onSelectFilter({
      type: 'your-posts',
    })
  }

  private handleSelectPeers = () => {
    const { onSelectFilter, yourRelation } = this.props
    onSelectFilter({
      type: 'peergroup',
      relationId: yourRelation.id,
    })
  }

  private handleSelectEveryone = () => {
    const { onSelectFilter } = this.props
    onSelectFilter({
      type: 'feedgroup',
      slug: 'everyone',
    })
  }

  private handleSelectFollowedPeople = () => {
    const { onSelectFilter } = this.props
    onSelectFilter({
      type: 'feedgroup',
      slug: 'followed_people',
    })
  }

  private handleSelectFollowedTags = () => {
    const { onSelectFilter } = this.props
    onSelectFilter({
      type: 'feedgroup',
      slug: 'followed_tags',
    })
  }

  private handleSelectFollowedPosts = () => {
    const { onSelectFilter } = this.props
    onSelectFilter({
      type: 'feedgroup',
      slug: 'followed_posts',
    })
  }
}
